import { Constant } from "src/constant";
import packageJson from '../../../../package.json';

export function buildGenericTags() {
    return {
        [Constant.resourceTagKeys['applicationID']]: Constant.resourceTagValues['applicationID'],
        [Constant.resourceTagKeys['version']]: packageJson.permissions.version,
    };
}
